import i18n from "@/i18n/index.js";

const baseURL = import.meta.env.VITE_APP_API_URL;

const http = {
  async get<T>(path: string): Promise<{ data: T }> {
    const url = new URL(path, baseURL);
    if (!url.searchParams.has("lang")) {
      url.searchParams.set("lang", i18n.global.locale.value);
    }

    const response = await fetch(url, {
      headers: { Accept: "application/json" },
    });

    if (!response.ok) {
      throw new Error(`GET ${url.pathname} failed with ${response.status}`);
    }

    return { data: (await response.json()) as T };
  },
};

export { http };
